import actions from "../../constants/actions";

const initialState = {
    homepage: null,
    reclamar_tempo: null,
    blog: null,
    artists: null,
    spaces: null,
    spaces_home: null,
    spaces_booking: null,
    open_calls: null,
    paulo_cunha_silva: null,
    info: null,
    tecnical_residencies: null,
    artistic_residencies: null,
    classes: null,
    cookies: null,
    privacy: null,
    cookies: null,
    terms: null,

    isLoading: false,
    error: null,
};

export default function pages(state = initialState, action) {
    switch (action.type) {
        case actions.PAGES.LOAD:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actions.PAGES.LOAD_SUCCESS:
            let newState = {
                ...state,
                isLoading: false,
                error: null,
            };

            newState[action.payload.key] = action.payload.data;

            return newState;
        case actions.PAGES.LOAD_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
